import { render } from "./InvitationWeddingListForm.vue?vue&type=template&id=672c8888&lang=true"
import script from "./InvitationWeddingListForm.vue?vue&type=script&lang=js"
export * from "./InvitationWeddingListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__